export interface ILocalesStrategy {
  setTranslations(locale: string): void;
}

export class LocalesService {
  public static getInstance() {
    if (!LocalesService._instance) {
      LocalesService._instance = new LocalesService();
    }

    return LocalesService._instance;
  }

  private static _instance: LocalesService;
  private _strategy: ILocalesStrategy;

  public set localesStrategy(value: ILocalesStrategy) {
    this._strategy = value;
  }
  public get localesStrategy(): ILocalesStrategy {
    if (!this._strategy) {
      throw new Error(
        'affiny-core/services/locales/locales.ts you cannot call .strategy before configure it. Search LocalesService.strategy setter method'
      );
    }

    return this._strategy;
  }

  public setLocalesStrategy = (strategy: ILocalesStrategy) => {
    this._strategy = strategy;
  };

  public setTranslations(locale: string): void {
    this._strategy && this._strategy.setTranslations(locale);
  }
}

export const localesService = LocalesService.getInstance();
